/**
 * 최근 활동 컴포넌트
 */

import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { RecentActivity as RecentActivityType } from '../../types/dashboard';
import { format } from 'date-fns';
import './RecentActivity.css';

interface RecentActivityProps {
  activities: RecentActivityType[];
}

const RecentActivity: React.FC<RecentActivityProps> = ({ activities }) => {
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'booking':
        return '📅';
      case 'payment':
        return '💳';
      case 'inquiry':
        return '📝';
      default:
        return '📌';
    }
  };

  const getActivityColor = (type: string) => {
    switch (type) {
      case 'booking':
        return '#00BCD4';
      case 'payment':
        return '#4CAF50';
      case 'inquiry':
        return '#FF9800';
      default:
        return '#9E9E9E';
    }
  };

  if (activities.length === 0) {
    return (
      <Card className="recent-activity-card">
        <Card.Body>
          <Card.Title className="recent-activity-title">최근 활동</Card.Title>
          <p className="text-muted">최근 활동 내역이 없습니다.</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="recent-activity-card">
      <Card.Body>
        <Card.Title className="recent-activity-title">최근 활동</Card.Title>
        <ListGroup variant="flush" className="recent-activity-list">
          {activities.map((activity) => (
            <ListGroup.Item
              key={activity.id}
              className="recent-activity-item"
              style={{ borderColor: 'rgba(255, 255, 255, 0.1)' }}
            >
              <div className="recent-activity-content">
                <div className="recent-activity-icon" style={{ color: getActivityColor(activity.type) }}>
                  {getActivityIcon(activity.type)}
                </div>
                <div className="recent-activity-text">
                  <div className="recent-activity-title-text">{activity.title}</div>
                  <div className="recent-activity-description">{activity.description}</div>
                  <div className="recent-activity-time">
                    {format(new Date(activity.created_at), 'yyyy년 MM월 dd일 HH:mm')}
                  </div>
                </div>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default RecentActivity;

